<script>
	import ClickElsewhere from 'components/click-elsewhere.vue';
	import OutboundLink from 'components/outbound-link.vue';

	export default {
		props: {
			helpText: {
				type: String
			},
			alignment: {
				default: 'bottom',
				type: String
			}
		},
		components: {
			'click-elsewhere': ClickElsewhere,
			'outbound-link': OutboundLink
		},
		data() {
			return {
				dialogOpen: false
			};
		},
		methods: {
			close(refocus) {
				this.dialogOpen = false;

				if (refocus) {
					this.$refs.toggleButton.focus();
				}
			},
			toggle() {
				this.dialogOpen = !this.dialogOpen;
			}
		},
		computed: {
			ariaLabel() {
				return `${this.helpText} disabled`;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.classroom-addon-lock-tooltip {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		--dialog-position: calc(100% + 1.5rem);

		.lock-button {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 1rem;
			width: 1rem;
			line-height: 1;
			background-color: $c-blue-accent-1;
			color: $c-white;
			border: none;
			border-radius: 0.5rem;

			.fa-lock {
				font-size: 0.5rem;
			}
		}

		.help-dialog {
			&.dialog-bottom {
				top: var(--dialog-position);
			}
			&.dialog-right {
				left: var(--dialog-position);
			}
		}

		.icon-container {
			background-color: $c-blue-accent-1;
			color: $c-white;
		}

		a {
			text-decoration: underline;

			&:hover {
				text-decoration: none;
			}
		}
	}

	button:disabled + .classroom-addon-lock-tooltip {
		position: absolute;
		top: calc(100% - 0.5rem);
		right: 0;
	}
</style>
<template>
	<click-elsewhere
		class="classroom-addon-lock-tooltip"
		@keydown.native.esc="close(true)"
		@clicked-elsewhere="close(false)">
		<button
			class="button -link lock-button"
			@click="toggle"
			type="button"
			aria-haspopup="dialog"
			:aria-label="ariaLabel"
			ref="toggleButton">
			<i class="fa-solid fa-lock"></i>
		</button>
		<div
			v-if="dialogOpen"
			class="classroom-addon-lock-dialog help-dialog"
			:class="`dialog-${alignment}`"
			role="dialog">
			<div class="icon-container help-dialog-icon-container">
				<i class="fa-solid fa-lock"></i>
			</div>
			<div class="help-dialog-body">
				To access all ReadWorks features. Log in at
				<outbound-link
					href="https://readworks.org/"
					target="_blank"
					data-outbound-link="GOOGLE_CLASSROOM_ADDON_TOOLTIP">
					ReadWorks.org
				</outbound-link>
			</div>
			<button
				class="hidden-visually focus-capture"
				aria-hidden="true"
				@focus="close(true)"></button>
		</div>
	</click-elsewhere>
</template>
